import React, { useState, useEffect } from "react";
import axios from "axios";

const ReportGenerator = () => {
    const [filterType, setFilterType] = useState("date");
    const [startDate, setStartDate] = useState("2025-01-01");
    const [endDate, setEndDate] = useState(new Date().toISOString().split("T")[0]);
    const [reportData, setReportData] = useState([]);

    // Fetch report data
    const fetchReportData = async () => {
        try {
            const response = await axios.get(
                `/api/reports`,
                {
                    params: {
                        filter: filterType,
                        start_date: startDate,
                        end_date: endDate,
                    },
                }
            );
            setReportData(response.data);
        } catch (error) {
            console.error("Error fetching report data:", error);
        }
    };

    // Export data to Excel or PDF
    const exportReport = async (type) => {
        try {
            const response = await axios.get(
                `/api/reports/export`,
                {
                    params: {
                        filter: filterType,
                        start_date: startDate,
                        end_date: endDate,
                        export: type,
                    },
                    responseType: "blob", // Important for downloading files
                }
            );

            // Create a blob URL and download the file
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `report_${filterType}.${type}`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error(`Error exporting report to ${type}:`, error);
        }
    };

    useEffect(() => {
        fetchReportData();
    }, [filterType, startDate, endDate]);

    return (
        <div>
            <h1>Report Generator</h1>

            <div>
                <label>Filter Type:</label>
                <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                    <option value="date">Date</option>
                    <option value="customer">Customer</option>
                    <option value="store">Store</option>
                </select>

                <label>Start Date:</label>
                <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />

                <label>End Date:</label>
                <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                />

                <button onClick={fetchReportData}>Generate Report</button>
            </div>

            <div>
                <h2>Report Data</h2>
                <table border="1">
                    <thead>
                        <tr>
                            {reportData.length > 0 &&
                                Object.keys(reportData[0]).map((key) => <th key={key}>{key}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {reportData.map((row, index) => (
                            <tr key={index}>
                                {Object.values(row).map((value, idx) => (
                                    <td key={idx}>{value}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div>
                <h2>Export Options</h2>
                <button onClick={() => exportReport("excel")}>Export to Excel</button>
                <button onClick={() => exportReport("pdf")}>Export to PDF</button>
            </div>
        </div>
    );
};

export default ReportGenerator;
